import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useState } from "react";
import { getTasks } from "../apis/lifecycle-data";


const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    float: 'right',
    paddingBottom: 1,
  },
  root: {
    backgroundColor: "#fff",
    borderRadius: 4,
  },
}));

export default function LifeCycle() {
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [q, setQ] = useState("");
  const [tasksChanged,setTasksChanged] = useState(false);
  
  const classes = useStyles();


  useEffect(() => {
    let mounted = true;
    if(tasks.length && !tasksChanged){
      return;
    }
    getTasks().then((tasks) => {

      if (mounted) {
        setTasks(tasks);
        var ftasks = [];
        tasks.forEach((x) => ftasks.push(x));
        setFilteredTasks(ftasks);
        setTasksChanged(false);
      }
    });
    return () => {console.log("Monitor is unmounted"); mounted = false};
  }, [tasksChanged,tasks]);

  function filterTable(filterString) {
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredTasks(tasks);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredTasks(
        tasks.filter((task) => {
          if (task.taskName.startsWith(filterString)) return true;

          if (task.description.startsWith(filterString)) return true;

          if (task.status.startsWith(filterString)) return true;

          if (task.environment.startsWith(filterString)) return true;
          if (task.host.startsWith(filterString)) return true;
          if (task.trigger.startsWith(filterString)) return true;


          console.log("no match ");
          console.dir(task);
        })
      );
    }
  }




  return (
    <div className="table-container">
      <Paper elevation={1}>
        <div className="search">
          <TextField
            label="Search"
            id="outlined-basic"
            size="small"
            className={classes.root}
            variant="outlined"
            onChange={(e) => filterTable(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

        </div>
        

        <table className="agentstb">
          <tr>
            <th>Bot Name</th>
            <th>Description</th>
            <th>Status</th>
            <th>Environment</th>
            <th>Host</th>
            <th>Trigger</th>
          </tr>
          {filteredTasks.map((task) => (
            <tr>
              <td>{task.taskName}</td>
              <td>{task.description}</td>
              <td>{task.status}</td>
              <td>{task.environment}</td>
              <td>{task.host}</td>
              <td>{task.trigger}</td>
            </tr>
          ))}
        </table>
      </Paper>
    </div>
  );
}
